import { OmIcon } from './OmIcon';

/**
 * author: Nick
 * id F1EE1708-7EAF-4929-97AA-D4BAC093D157
 * name om
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/om.svg
 * tags
 * - Religion 
 */
export const ReligionHinduIcon = OmIcon;
export default ReligionHinduIcon